import {StyleSheet, css} from 'aphrodite';
import React from 'react';

import {useRolloutFlags} from 'launchdarkly/LaunchDarklyUtil';
import Tooltip from 'ui-library/bs/Tooltip';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import {GRAY_DARK} from 'ui-library/Colors';

interface ToggleAnalysisSidebarButtonProps {
  sidebarIsOpen: boolean;
  toggleSidebar: () => void;
}

export default function ToggleAnalysisSidebarButton({
  sidebarIsOpen,
  toggleSidebar: toggleSidebarOpen,
}: ToggleAnalysisSidebarButtonProps): JSX.Element {
  const {analysisToolEnableHeaderRedesign} = useRolloutFlags();
  return (
    <Tooltip title={sidebarIsOpen ? 'Close sidebar' : 'Open sidebar'}>
      <Button
        buttonStyle={analysisToolEnableHeaderRedesign ? ButtonStyle.TERTIARY_WHITE : ButtonStyle.CIRCLE_ICON}
        className={css(styles.button)}
        icon={sidebarIsOpen ? 'chevron-left' : 'chevron-right'}
        onClick={() => {
          toggleSidebarOpen();
        }}
        size={analysisToolEnableHeaderRedesign ? ButtonSize.SMALL : ButtonSize.MEDIUM}
        dataTestAttrs={{component: 'ToggleAnalysisSidebarButton', element: 'root'}}
      />
    </Tooltip>
  );
}

const styles = StyleSheet.create({
  button: {
    fontSize: 16,
    color: GRAY_DARK,
  },
});
